import Option from "./Option";

const Options = (props) => {
  return (
    <div>
      <div className="widget-header">
        <h3 className="widget-header__title">Your Options</h3>
        <button className="button button--link" onClick={props.handleRemoveAll}>
          Remove All
        </button>
      </div>
      {props.options.length === 0 && (
        <p className="widget__message">Please add an option to get started</p>
      )}
      <div>
        {props.options.map((option, index) => (
          <Option
            key={option}
            count={index + 1}
            handleRemove={props.handleRemove}
            option={option}
          />
        ))}
      </div>
    </div>
  );
};

export default Options;
